import SolidButton from "@/app/components/ui/Buttons/SolidButton";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setShiftDetails } from "@/app_redux/reducers/slices/auth/rota_slice";
import { useNavigate } from "react-router";

const TaxHeaderSection = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handelAddNavigate = () => {
    navigate(`/app/inventory/tax-add`);
    dispatch(setShiftDetails({ data: null }));
  };

  return (
    <div className="my-2 px-4 sm:px-6 w-full rounded-md flex flex-row items-center justify-between gap-3">
      <h3 className="text-sm sm:text-base font-semibold whitespace-nowrap">Listed Tax Types</h3>

      <div className="shrink-0">
        <SolidButton onButtonClick={() => handelAddNavigate()} size="XL">
          + Add Tax Type
        </SolidButton>
      </div>
    </div>
  );
};
export default TaxHeaderSection;
